<div class="mark-as-read-container">
  <a (click)="markAllAsRead()" color="primary" mat-button title="Mark all as read">Mark all as read</a>
  <button (click)="popoverInstance.closePopover($event)" class="close-btn" isIconButton="true" mat-button>
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
<div class="notifications-container">
  @if (notifications && notifications.length > 0) {
    <cdk-virtual-scroll-viewport
      [maxBufferPx]="1000"
      [minBufferPx]="450"
      class="notifications-virtual-scroll-container"
      itemSize="150"
    >
      <ng-container *cdkVirtualFor="let notification of notifications">
        <notifications-list-element
          [notification]="notification"
          (checkDetailsClicked)="popoverInstance.closePopover($event)"
        ></notifications-list-element>
      </ng-container>
    </cdk-virtual-scroll-viewport>
  } @else {
    <div class="notifications-zero-screen">
      <h5>Sorry, we couldn't find new notifications</h5>
      @if (!(loading$ | async)) {
        <button (click)="refreshNotifications()" color="accent" mat-flat-button>Refresh</button>
      } @else {
        <loader color="primary"></loader>
      }
    </div>
  }
</div>
